import { Toast } from "mint-ui";
import axios from "axios";
import userStorage from "./userStorage"
let ajaxGet = function (url, data) {
  data.vv = 6;

  return axios.get(url, data).then(res => {
    if (res.data.resultCode == 0) {
      return res.data;
    } else {
      msg(res.data.resultMsg);

      // 返回是营业日期不符的话，清空一下本地缓存
      if (res.data.resultCode == 2){
        userStorage.doLogout()
        console.log('do something')
      }
    }
  });
};
let ajaxPost = function (url, data) {
  return axios.post(url, data, { vv: 6 }).then(res => {
    if (res.data.resultCode == 0) {
      return res.data;
    } else {
      msg(res.data.resultMsg);
      // 返回是营业日期不符的话，清空一下本地缓存
      if (res.data.resultCode == 2){
        userStorage.doLogout()
        console.log('do something')
      }
    }
  })
}
let msg = function (msg) {
  Toast({
    message: msg,
    position: "bottom",
    duration: 3000
  });
};

export default ajaxGet;
export { ajaxPost }



// WEBPACK FOOTER //
// ./src/conf/ajaxGet.js